import { render, staticRenderFns } from "./DetailClassV2.vue?vue&type=template&id=43df2779&"
import script from "./DetailClassV2.vue?vue&type=script&lang=js&"
export * from "./DetailClassV2.vue?vue&type=script&lang=js&"
import style0 from "./DetailClassV2.vue?vue&type=style&index=0&id=43df2779&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports